/**
 * ChatMenu Component
 * ==================
 * 
 * Dropdown menu for chat actions:
 * - Share private gallery
 * - Report user
 * - Block user
 */
import React from 'react';
import { Shield } from 'lucide-react';

export function ChatMenu({
  show,
  onClose,
  onSharePrivateGallery,
  onReport,
  onBlock,
  isGrantingPrivateAccess,
  hasPrivateGalleryAccess,
}) {
  if (!show) return null;
  
  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 z-10"
        onClick={onClose}
      />
      
      {/* Menu */}
      <div 
        className="absolute right-0 mt-2 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-600 rounded-lg shadow-lg text-sm z-20 w-48"
        data-testid="chat-menu-dropdown"
      >
        {/* Give Private Gallery Access */}
        {onSharePrivateGallery && (
          <button
            onClick={onSharePrivateGallery}
            disabled={isGrantingPrivateAccess || hasPrivateGalleryAccess}
            className={`w-full text-left px-4 py-2 hover:bg-gray-50 dark:hover:bg-slate-700 ${
              hasPrivateGalleryAccess ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700 dark:text-gray-200'
            }`}
            type="button"
          >
            {isGrantingPrivateAccess 
              ? 'Granting...' 
              : hasPrivateGalleryAccess 
              ? '✓ Gallery Shared' 
              : '📸 Share Private Gallery'
            }
          </button>
        )}
        
        <hr className="border-gray-200 dark:border-slate-600" />
        
        {/* Report */}
        <button
          onClick={onReport}
          className="w-full text-left px-4 py-2 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-slate-700 flex items-center gap-2"
          type="button"
        >
          <Shield className="w-4 h-4" />
          Report User
        </button>
        
        {/* Block */}
        <button
          onClick={onBlock}
          className="w-full text-left px-4 py-2 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 flex items-center gap-2"
          type="button"
        >
          <span className="text-red-600">🚫</span>
          Block User
        </button>
      </div>
    </>
  );
}

export default ChatMenu;
